import { permissionGroupHelper, UserToken } from "../amorg-common";

export const clientAccessHelper = {
    canAccessIncidents: (activeUser: UserToken | null) =>  
            activeUser && 
            activeUser.features.includes('EmployeePortal') && 
            activeUser.features.includes('Incidents') && 
            (
                activeUser.individualPermissions.some(p => p === 'ManageIncidents') || 
                permissionGroupHelper.hasPermission(activeUser.permissionGroupId, 'ManageIncidents')
            )
            ? true
            : false
};